import { Select, SelectProps } from "antd";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import { TipoItemRelatorioPrestacaoContas } from "features/relatorios/prestacao-contas/typings";

const { Option } = Select;

export interface SelectTipoItemConfiguracaoRelatorioProps<T = any>
  extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectTipoItemConfiguracaoRelatorio({
  value,
  ...rest
}: SelectTipoItemConfiguracaoRelatorioProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option
        value={TipoItemRelatorioPrestacaoContas.Capa}
        key={TipoItemRelatorioPrestacaoContas.Capa}
      >
        Capa
      </Option>
      <Option
        value={TipoItemRelatorioPrestacaoContas.Relatorio}
        key={TipoItemRelatorioPrestacaoContas.Relatorio}
      >
        Relatório
      </Option>
      <Option
        value={TipoItemRelatorioPrestacaoContas.PdfExterno}
        key={TipoItemRelatorioPrestacaoContas.PdfExterno}
      >
        PDF Avulso
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectTipoItemConfiguracaoRelatorio;
